import { Button, Card, Checkbox, Col, Row, Tag } from "antd";
import { PlusIcon } from "../../../../../atoms/CustomIcons";
import Chart from "../../Chart";

export default function TabDashboard() {
  return (
    <div className="dashboardTabContent">
      <Row gutter={16} wrap={false}>
        <Col span={7}>
          <div className="checklist">
            <div className="title">
              <h4>Checklist</h4>
              <Button
                className="outlined-btn"
                size="small"
                style={{ height: "28px", width: "28px", padding: "0" }}
              >
                <PlusIcon />
              </Button>
            </div>
            <div className="content">
              <Card className="checklistCard dashboardChecklistCard">
                <div className="checkList_listing">
                  <Checkbox>Complete estimate</Checkbox>

                  <div className="checklistFooter">
                    <Tag className="grey_tag"> Due date: Apr 23 </Tag>
                    <div style={{ marginLeft: 8 }}>
                      <img
                        src="/images/myProfile/upload-avatar.png"
                        alt=""
                        style={{
                          width: "28px",
                          height: "28px",
                          border: "1px solid #C7D1D4",
                          borderRadius: "100%",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="checkList_listing">
                  <Checkbox>Complete estimate</Checkbox>

                  <div className="checklistFooter">
                    <Tag className="grey_tag"> Due date: Apr 23 </Tag>
                    <div style={{ marginLeft: 8 }}>
                      <img
                        src="/images/myProfile/upload-avatar.png"
                        alt=""
                        style={{
                          width: "28px",
                          height: "28px",
                          border: "1px solid #C7D1D4",
                          borderRadius: "100%",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </Col>
        <Col span={17}>
          <div className="chart">
            <div className="title">
              <h4>Charts</h4>
              <Button
                className="outlined-btn"
                size="small"
                style={{ height: "28px", width: "28px", padding: "0" }}
              >
                <PlusIcon />
              </Button>
            </div>
            <div className="content">
              <Card>
                <Chart />
              </Card>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
